/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { useEffect, useCallback, useContext, useState } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom'
import TopHeader from '../../../../components/TopHeader'
import GlobalContext from '../../../../components/Context/GloablContext'
import EmptyScreen from '../../../../components/EmptyScreen'
import Pagination from '../../../../components/Pagination'
import Limit from '../../../../components/Limit'
import { useExportPatientExportLogMutation, useGetHelpGuideOrganizationQuery, useGetPatientViewExportHistoryQuery } from '../../../../slices/patientSlice'
import CustomOverLay from '../../../../components/CustomOverLay'

import ManageExportTable from './Components/Table'
import PatientActivityHistoryTopBar from '../ManagePatientActivityHistory/Component/Topbar/Index'
import { dataService } from '../../../../services/data.services'
import { handleSystemConfig } from '../../../../redux/systemConfigSlice'
import HelpGuideModal from '../../../../components/HelpGuideModal'



export default function ManagePatientExportHistory() {
    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar } = useContext(GlobalContext);
    const { username } = useParams()
    const [limit, setLimit] = useState("15")
    const [exportPatientExport] = useExportPatientExportLogMutation()
    const dispatch = useDispatch()
    const [suggestions, setSuggestions] = useState("")
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams({});
    const viewId = useSelector((state) => state?.systemConfigData?.viewToHistory)
    const organization_id = useSelector((state) => state?.systemConfigData?.organization_id)
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
    
    const { data, isFetching, isLoading, isError, status, isSuccess } = useGetPatientViewExportHistoryQuery(searchParams?.toString(), { skip: searchParams.size < 4, refetchOnMountOrArgChange: true })

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    function handleNoOfRowsClick(number) {

        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });

    }
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        if (key === 'search') {
            params[key] = encodeURIComponent(value);
        } else {
            params[key] = value;
        }
        if (params.search === '') delete params.search;
        setSearchParams({ ...params });
    }

    const handleDispatch = useCallback(() => {
        if (!searchParams.get('limit')) {
            handleSearchParams('limit', '15');
        }
        if (!searchParams.get('page_number')) {
            handleSearchParams('page_number', '1');
        }
        if (!searchParams.get('filter')) {
            handleSearchParams('filter', 'true');
        }
        if (!searchParams.get('target_user_name') && location.state !== null) {
            handleSearchParams('target_user_name', location.state.target_user_name)
        }
    }, [location]);

    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */

    useEffect(() => {
        handleDispatch()

    }, [handleDispatch]);


    // const optimizedFn = useCallback(
    //     Debounce((value) => handleChange(value)),
    //     [searchParams]
    // );

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                dispatch(handleSystemConfig(response.data.data))
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-patients-export-logs');
        } else {
            setQueryParamsorg('type=org-user-patients-export-logs');
        }
    }, [userType]);
          
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);
        
    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Export History"} />
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6">
                        <div className='flex items-center mb-3.5'>
                            <Link to="/manage-patients">
                                <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                            </Link>
                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>

                            <Link to={`/manage-patients/view-patient/${viewId}`}>
                                <h1 className="text-sm font-normal text-[#52555D]">View Patient</h1>
                            </Link>
                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>

                            <Link to={`/manage-patients/activity_history`} state={[searchParams.get("target_user_name")]}>
                                <h1 className="text-sm font-normal text-[#52555D]">Activity Log</h1>
                            </Link>
                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                            <div>
                                <h1 className="text-sm font-normal text-[#008586]">Export History</h1>
                            </div>
                            <span onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        </div>
                        <PatientActivityHistoryTopBar
                            path={'/manage-patients/activity_history'}
                            pathPlaceholder={'Go back to Activity Log'}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            exportObservers={exportPatientExport}
                            data={data}
                            isExportList={true}
                            isExport={true}
                            exportCols={['Username', 'Timestamp', 'Filter Name', 'Table Name', 'Exported Column Name']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            username={searchParams.get("target_user_name")}
                            exportMonitorExport={exportPatientExport}
                            isIdexport={true}
                        />
                    </div>
                    {((isFetching && status !== "fulfilled" && status !== "rejected") || (data === undefined && status !== "fulfilled" && status !== "rejected")) ? <CustomOverLay Active text="Loading Export History..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay1' : 'overlay-list1'}`} /> : (data !== undefined && data?.data?.length > 0) ? <>
                        <div className="px-6">
                            <ManageExportTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-[95%] px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]" id="total_records">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />

                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {data?.data.length === 0 &&
                        <EmptyScreen title={"Export History"}
                            FirstPTag={"No export history to view yet"} />
                        }
                    </>}

                </div>
            </div>
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
    )
}
